import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var img1 = require('./../../images/background/bg5.jpg');

class OurProject3 extends React.Component {
    state = {
        projects: [],
        services: [],
        loading: true
    };

    componentDidMount() {
        this.fetchData();
    }

    async fetchData() {
        try {
            const [projectsRes, servicesRes] = await Promise.all([
                axiosClient.get(apiConfig.PROJECTS.GET_ALL + '?per_page=10'),
                axiosClient.get(apiConfig.SERVICES.GET_ALL)
            ]);

            this.setState({
                projects: projectsRes.data.data,
                services: servicesRes.data.data,
                loading: false
            }, () => {
                if (window.initMasonryAndPopup) {
                    setTimeout(() => {
                        window.initMasonryAndPopup();
                    }, 100);
                }
            });
        } catch (error) {
            console.error("Error fetching data", error);
            this.setState({ loading: false });
        }
    }

    render() {
        const { projects, services, loading } = this.state;
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-parallax bg-cover mobile-page-padding" data-stellar-background-ratio="0.5" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator text-white">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Project</h2>
                                </div>
                            </div>
                        </div>
                        
                        {loading ? (
                            <div className="text-center text-white p-a50">Loading projects...</div>
                        ) : (
                            <>
                                <div className="filter-wrap p-b15 center">
                                    <ul className="masonry-filter link-style text-uppercase white">
                                        <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                        {services.map((item, index) => (
                                            <li key={index}><NavLink to={"#"} data-filter={`.cat-${item.slug}`} data-hover={item.name}>{item.name}</NavLink></li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                    {projects.map((item, index) => {
                                        const filterClass = item.service ? `cat-${item.service.slug}` : '';
                                        return (
                                            <div key={index} className={`${filterClass} masonry-item col-md-3 col-sm-6 m-b30`}>
                                                <div className="mt-box image-hover-block">
                                                    <div className="mt-thum-bx">
                                                        <img src={item.featured_image} alt={item.title} />
                                                    </div>
                                                    <div className="mt-info p-t20 text-white">
                                                        <h4 className="mt-tilte m-b10 m-t0">{item.title}</h4>
                                                        <p className="m-b0">{item.location || 'Location Not Specified'}</p>
                                                    </div>
                                                    <NavLink to="/project-detail" state={{ projectSlug: item.slug }}></NavLink>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </>
        );
    }
};

export default OurProject3;
